import { useEffect, useId, useRef, type ReactNode } from "react";
import "./dialog.css";

/** Bestätigung für Schritte mit Datenverlust; der Fokus bleibt im Dialog. */
export function Bestaetigung({
  offen,
  titel,
  children,
  bestaetigen,
  gefahr = false,
  deaktiviert = false,
  onBestaetigen,
  onAbbrechen,
}: {
  offen: boolean;
  titel: string;
  children: ReactNode;
  bestaetigen: string;
  gefahr?: boolean;
  deaktiviert?: boolean;
  onBestaetigen: () => void;
  onAbbrechen: () => void;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  const kennung = useId();
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (offen && !d.open) d.showModal();
    if (!offen && d.open) d.close();
  }, [offen]);
  return (
    <dialog ref={ref} className="dialog" aria-labelledby={kennung} onCancel={(e) => {
      e.preventDefault();
      onAbbrechen();
    }}>
      <h2 id={kennung}>{titel}</h2>
      <div className="dialog-text">{children}</div>
      <div className="dialog-knoepfe">
        <button type="button" className="knopf" onClick={onAbbrechen}>
          Abbrechen
        </button>
        <button type="button" className={`knopf ${gefahr ? "knopf-gefahr-voll" : "knopf-primaer"}`} onClick={onBestaetigen} disabled={deaktiviert} autoFocus={!deaktiviert}>
          {bestaetigen}
        </button>
      </div>
    </dialog>
  );
}
